import { safeDefine } from "../../registration/safe-define.js";
import { ThumbnailElement } from "../../ui/thumbnail/element.js";
//#region src/define/ui/thumbnail.ts
safeDefine(ThumbnailElement);
//#endregion
